import axios, { AxiosRequestHeaders, AxiosProgressEvent } from 'axios';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function get(url: string, queries?: any, headers?: AxiosRequestHeaders) {
    return axios.get(url, {
        params: queries,
        headers,
    });
}

export async function post(url: string, data?: object, headers?: AxiosRequestHeaders) {
    return axios.post(url, data, {
        headers
    });
}

//Get yout Client ID here: http://api.imgur.com/
const imgurClientIds = [
    'ed03938f3ff9c55',
    'fada7b81b37ee0a',
    '44d107a9b53bbf5',
    'be1c5cf3222ac27',
];

export async function uploadImgur(file: File, onUploadProgress?: (e: AxiosProgressEvent) => void) {
    const data = new FormData();
    data.append('image', file);

    const clientId = imgurClientIds[Math.floor(Math.random() * imgurClientIds.length)];

    return axios.post('https://api.imgur.com/3/image', data, {
        headers: {
            Authorization: `Client-ID ${clientId}`,
        },
        onUploadProgress,
    });
}

export async function deleteImgur(deletehash: string, clientId: string) {
    // TODO: Remember last client id
    return axios.delete('https://api.imgur.com/3/image/' + deletehash, {
        headers: {
            Authorization: `Client-ID ${clientId}`,
        },
    });
}

export default {
    uploadImgur, post, get, deleteImgur,
}
